export default "__VITE_ASSET__C9xw8O2C__"